import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CloseDialogButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, closeDialog, currentDialog} = useTextareaComponent();


let isCanCloseDialog = computed(() => {
    if (OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.manualFinishDialogs, client.value.siteId)) {
        return !!currentDialog.value;
    }
    return false;
});




return (_ctx: any,_cache: any) => {
  return (_unref(isCanCloseDialog))
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: "flag-checkered",
        tooltip: _unref(__)('Завершить диалог'),
        onClick: _unref(closeDialog)
      }, null, 8, ["tooltip", "onClick"]))
    : _createCommentVNode("", true)
}
}

})